import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { KtdGridComponent, KtdGridItemResizeEvent, KtdGridLayout, ktdTrackById } from '@katoid/angular-grid-layout';
import { fromEvent, merge, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { countriesPopulation, countriesPopulationByYear } from './data/countries-population.data';
import { volumeByQueue } from './data/contact-center.data';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { DOCUMENT } from '@angular/common';


@Component({
    selector: 'ktd-real-life-example',
    templateUrl: './real-life-example.component.html',
    styleUrls: ['./real-life-example.component.scss']
})
export class KtdRealLifeExampleComponent implements OnInit, OnDestroy {
    @ViewChild(KtdGridComponent, {static: true}) grid: KtdGridComponent;
    trackById = ktdTrackById;

    cols = 200; //12;
    rowHeight = 10; //50;
  //  compactType: 'vertical' | 'horizontal' | null = 'vertical';
    layout: KtdGridLayout = [
        {   id: '0', x: 0, y: 0, w: 72, h: 26      },   // Contact Details
        {   id: '1', x: 72, y: 0, w: 72, h: 26     },   // NBA Details
        {   id: '2', x: 0, y: 5, w: 130, h: 33     },   // Products
        {   id: '3', x: 130, y: 5, w: 70, h: 58    },   // Contact
        {   id: '4', x: 0, y: 10, w: 130, h: 25    },   // Claims
        {   id: '5', x: 144, y: 0, w: 56, h: 26    }    // Volume
    ];


    layoutSizes: { [id: string]: [number, number] } = {};

//    countriesPopulation: any[] = countriesPopulation;
//    countriesPopulationByYear: any[] = countriesPopulationByYear;

    volumeByQueue: any[] = volumeByQueue;

    // options
    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Countries';
    yAxisLabel: string = 'Population';
    timeline: boolean = true;
    preventCollision: boolean = true;
    compactType = null;


    colorScheme: Color = {
        domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5'],
        group: ScaleType.Ordinal,
        selectable: true,
        name: 'Customer Usage'
    };

    colorScheme2: Color = {
        domain: ['#4e79a7', '#f28e2c', '#e15759', '#76b7b2', '#59a14f', '#edc949', '#af7aa1'],
        group: ScaleType.Ordinal,
        selectable: true,
        name: 'vertical stacked'
    };

    colorSchemeGradientLinear: Color = {
        domain: ['#4e79a7', '#f28e2c', '#e15759'],
        group: ScaleType.Ordinal,
        selectable: true,
        name: 'color gradient'
    };

    legendBelow = LegendPosition.Below;
    schemeType = ScaleType.Linear;


    private resizeSubscription: Subscription;

    constructor(@Inject(DOCUMENT) public document: Document, private cd: ChangeDetectorRef) { }

    ngOnInit() {
        this.resizeSubscription = merge(
            fromEvent(window, 'resize'),
            fromEvent(window, 'orientationchange')
        ).pipe(
            debounceTime(50)
        ).subscribe(() => {
            this.grid.resize();
            this.calculateLayoutSizes();
        });
    }

    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
    }

    getView(gridItemId: string, grid: KtdGridComponent): [number, number] {
        const gridItemRenderData = grid.getItemRenderData(gridItemId);
        return [
            gridItemRenderData.width,
            gridItemRenderData.height
        ];
    }

    onLayoutUpdated(layout: KtdGridLayout) {
        this.layout = layout;
        this.calculateLayoutSizes();
    }

    labelFormatting(c) {
        return `${(c.label)} Population`;
    }

    onSelect(id: string, data): void {
        console.log('Item clicked', JSON.parse(JSON.stringify(data)));
    }

    onActivate(id: string, data): void {
        console.log('Activate', JSON.parse(JSON.stringify(data)));
    }

    onDeactivate(id: string, data): void {
        console.log('Deactivate', JSON.parse(JSON.stringify(data)));
    }

    onGridItemResize(gridItemResizeEvent: KtdGridItemResizeEvent) {
        console.log('onGridItemResize', gridItemResizeEvent);
        this.layoutSizes[gridItemResizeEvent.gridItemRef.id] = [gridItemResizeEvent.width, gridItemResizeEvent.height];
        this.cd.detectChanges();
    }

    /**
     * Calculates and sets the property 'this.layoutSizes' with the [width, height] of every item.
     * This is needed to set manually the [width, height] for every grid item that is a chart.
     */
    private calculateLayoutSizes() {
        const gridItemsRenderData = this.grid.getItemsRenderData();
        this.layoutSizes =
            Object.keys(gridItemsRenderData)
                .reduce((acc, cur) => ({
                    ...acc,
                    [cur]: [gridItemsRenderData[cur].width, gridItemsRenderData[cur].height]
                }), {});
    }

}
